import { createSelector } from 'reselect';

// TODO (josh) : this key should come from a constant
const getUser = state => state.user;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getFlagParam = createParameterSelector(params => params.flag);

export const getUserFlag = createSelector([getUser, getFlagParam], (user, flagName) => {
  // if user.flags is not defined (aka - login / signup pages) return false
  if (!user.flags) return false;
  return user.flags[flagName];
});

// TODO: (josh) These selectors below need to be refactored
//
export const getRecurringMeetingWithoutWorkspaces = () => state => {
  const {
    workspaces,
    user: { recurringMeetings },
  } = state;
  const recurrentMeetingWithWorkspacesIds = workspaces
    .map(({ recurringMeeting, recurringMeetingId }) => recurringMeeting?.id || recurringMeetingId)
    .filter(n => n);

  return recurringMeetings.filter(({ id }) => !recurrentMeetingWithWorkspacesIds.includes(id));
};
